import NoData from "./NoData"
import gpraStyles from "../../styles/Participant-GPRA.module.css"
import { ReactComponent as LockIcon } from "./Resources/lock.svg"

const Locked = () => {
  return (
    <div className={gpraStyles.no_record_div}>
      <NoData
        icon={
          <LockIcon
            style={{
              padding: "10.5px",
              width: "100%",
              height: "100%",
            }}
          />
        }
      />
      <div className={gpraStyles.noDataMsgContainer}>
        <p className={gpraStyles.noDataHeader}>
          GPRA is not enabled for this organization
        </p>
        <p className={gpraStyles.noDataMessage}>
          The GPRA service is not enabled for your organization. Please speak to
          your organization/enterprise administrator about enabling it.
        </p>
      </div>
    </div>
  )
}
export default Locked
